<template>
    <!-- <left_sidebar :aside="aside">
    <router-view />
  </left_sidebar> -->

    <div class="cont">
        <div class="left_wrapper">
            <div class="left_bar">
                <img class="left_bar_img" src="http://img-yimou.oss-cn-hangzhou.aliyuncs.com/logo%402x.png" alt="" />
                <div class="left_bar_list">
                    <div class="left_bar_item" v-for="item in barlist" :key="item.id"
                        :class="item.id == seleId ? 'isact' : ''" @click="seleClick(item)">
                        <img class="left_bar_item_img" :src="item.id == seleId ? item.selimgurl : item.imgurl" alt="" />
                        <div class="left_bar_item_tit">{{ item.title }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right_wrapper">
            <left_sidebar :aside="aside">
                <router-view />
            </left_sidebar>
        </div>
    </div>
</template>
<script>
import left_sidebar from "@/structures/left_sidebar";
import Cookies from "js-cookie";
export default {
    data() {
        return {
            seleId: "1",
            barlist: [
                {
                    title: "经营分析",
                    id: "1",
                    imgurl: require("../../../assets/ym/jyfxwxz@2x.png"),
                    selimgurl: require("../../../assets/ym/jyfxxz@2x.png"),
                },
                {
                    title: "渠道追踪",
                    id: "2",
                    imgurl: require("../../../assets/ym/qdzzwxz@2x.png"),
                    selimgurl: require("../../../assets/ym/qdzz@2x.png"),
                },

                {
                    title: "模版管理",
                    id: "3",
                    imgurl: require("../../../assets/ym/mbglwxz@2x.png"),
                    selimgurl: require("../../../assets/ym/mbglxz@2x.png"),
                },
                {
                    title: "设置",
                    id: "4",
                    imgurl: require("../../../assets/ym/szwxz@2x.png"),
                    selimgurl: require("../../../assets/ym/szxzxz@2x.png"),
                },
                {
                    title: "收支记账",
                    id: "5",
                    imgurl: require("../../../assets/ym/szjzwxz@2x.png"),
                    selimgurl: require("../../../assets/ym/szjzxz@2x.png"),
                },
            ],

            aside: JSON.parse(localStorage.getItem('Menuroute')),

            operateList: [
                {
                    name: "财务报表",
                    path: "dashboard",
                    children: [
                        {
                            name: "综合指标",
                            path: "dashboardcompre",
                        },
                        {
                            name: "利润日报",
                            path: "profit",
                        },
                        {
                            name: "渠道",
                            path: "channel",
                        },
                        {
                            name: "店铺",
                            path: "store",
                        },
                        {
                            name: "商品链接",
                            path: "shoplink",
                        },
                        {
                            name: "商品编码",
                            path: "encoding",
                        },
                        {
                            name: "规格编码",
                            path: "specicode",
                        },
                        {
                            name: "外部编码",
                            path: "outwardcode",
                        },
                    ],
                },
                {
                    name: "运营报表",
                    path: "opertable",
                    children: [
                        {
                            name: "渠道",
                            path: "channeloper",
                        },
                        {
                            name: "店铺",
                            path: "shopoper",
                        },
                        {
                            name: "商品链接",
                            path: "linkoper",
                        },
                        {
                            name: "商品编码",
                            path: "codeoper",
                        },
                        {
                            name: "规格编码",
                            path: "specioper",
                        },
                        {
                            name: "外部编码",
                            path: "outwardoper",
                        },
                    ],
                },
                {
                    name: "费用管理",
                    path: "costmanage",
                    children: [
                        {
                            name: "平台费用",
                            path: "terrace",
                        },
                        {
                            name: "科目费用",
                            path: "subject",
                        },
                    ],
                },
            ],

            channelList: [
                {
                    name: "全渠道",
                    path: "channel",
                    children: [
                        {
                            name: "全渠道核心",
                            path: "channelcore",
                        },
                        {
                            name: "特殊单分析",
                            path: "special",
                        },
                        {
                            name: "绩效分析",
                            path: "merits",
                        },
                    ],
                },
                {
                    name: "淘宝",
                    path: "taobao",
                    children: [
                        {
                            name: "运营概况",
                            path: "operation",
                        },
                        {
                            name: "推广分析",
                            path: "popularize",
                        },
                        {
                            name: "目标追踪",
                            path: "target",
                        },
                    ],
                },
                {
                    name: "拼多多",
                    path: "pinduoduo",
                    children: [
                        {
                            name: "运营概况",
                            path: "opersitu",
                        },
                        {
                            name: "推广分析",
                            path: "pddpopularize",
                        },
                        {
                            name: "目标追踪",
                            path: "pddtarget",
                        },
                    ],
                },
                {
                    name: "京东",
                    path: "jingdong",
                    children: [
                        {
                            name: "运营概况",
                            path: "jdopersitu",
                        },
                        {
                            name: "推广分析",
                            path: "jdpopularize",
                        },
                        {
                            name: "目标追踪",
                            path: "jdtarget",
                        },
                    ],
                },
            ],

            goodsList: [
                {
                    name: "商品管理",
                    path: "goodsmanage",
                    children: [
                        {
                            name: "成本模板及配置",
                            path: "costset", // ledger-finance
                        },
                        {
                            name: "订单费用模板",
                            path: "costorder", // ledger-finance
                        },
                        {
                            name: "责权模板配置",
                            path: "costduty", // ledger-finance
                        },
                    ],
                },
            ],

            setList: [
                {
                    name: "数据中心",
                    path: "data_center",
                    children: [
                        {
                            name: "平台订单",
                            path: "plateorder", // ledger-finance
                        },
                        {
                            name: "平台账单",
                            path: "platebill", // ledger-finance
                        },
                        {
                            name: "推广账单",
                            path: "promotion", // ledger-finance
                        },
                        {
                            name: "京东售后",
                            path: "jdsh", // ledger-finance
                        },
                        {
                            name: "线下费用账单",
                            path: "offbilling", // ledger-finance
                        },
                        {
                            name: "线下费用_售后登记",
                            path: "offbillingafter", // ledger-finance
                        },
                        {
                            name: "线下费用_补发",
                            path: "offbillingreissue", // ledger-finance
                        },
                    ],
                },
                {
                    name: "店铺管理",
                    path: "shopmanage",
                    children: [
                        {
                            name: "店铺管理",
                            path: "shoplist", // ledger-finance
                        },
                    ],
                },
                {
                    name: "权限管理",
                    path: "power_ment",
                    children: [
                        {
                            name: "人员管理",
                            path: "personment", // ledger-finance
                        },
                        {
                            name: "角色权限管理",
                            path: "rolement", // ledger-finance
                        },
                        {
                            name: "路由管理",
                            path: "manager", // ledger-finance
                        },
                    ],
                },
                {
                    name: "目标设置",
                    path: "targetset",
                    children: [
                        {
                            name: "综合指标设置",
                            path: "synthetical", // ledger-finance
                        },
                        {
                            name: "公司目标设置",
                            path: "companytarget", // ledger-finance
                        },
                        {
                            name: "人员目标设置",
                            path: "persontarget", // ledger-finance
                        },
                    ],
                },
            ],

            revenList: [
                {
                    name: "收支记账",
                    path: "reven",
                    children: [
                        {
                            name: "收支记账",
                            path: "revenbook", // ledger-finance
                        },
                    ],
                },
            ],
        };
    },
    components: {
        left_sidebar,
    },

    mounted() {
        // console.log('this.aside--->',JSON.stringify(this.aside));
        // this.operateList = this.cleanList(this.operateList,this.aside);
        // this.channelList = this.cleanList(this.channelList,this.aside);
        // this.goodsList = this.cleanList(this.goodsList,this.aside);
        this.setList = this.cleanList(this.setList, this.aside);
        // this.revenList = this.cleanList(this.revenList,this.aside);
        // console.log('this.test--->',JSON.stringify(test));
        this.seleIdFun();
    },

    methods: {
        cleanList(operateList, menuData) {
            // 1. 构建映射表：key=一级菜单纯path（去/），value=该菜单下有效子项path数组
            var menuPathMap = {};

            // 遍历一级菜单
            menuData.forEach(function (topMenu) {
                // 提取一级菜单的纯path（去掉开头的/，如/dashboard → dashboard）
                var topPurePath = topMenu.path.replace(/^\//, '');
                menuPathMap[topPurePath] = [];

                // 若该一级菜单有子项，提取子项的有效path（拆分后取后半部分）
                if (topMenu.children && topMenu.children.length > 0) {
                    topMenu.children.forEach(function (childMenu) {
                        // 拆分子项path（如dashboard/dashboardcompre → ["dashboard", "dashboardcompre"]）
                        var pathParts = childMenu.path.split('/');
                        // 取最后一部分作为匹配的子path
                        var childPurePath = pathParts[pathParts.length - 1];
                        // 避免重复添加
                        if (menuPathMap[topPurePath].indexOf(childPurePath) === -1) {
                            menuPathMap[topPurePath].push(childPurePath);
                        }
                    });
                }
            });
            console.log("路由第一个参数", operateList)
            console.log("路由第一个参数menuPathMap", menuPathMap)
            // 2. 处理operateList：保留所有一级项，过滤子项
            var processedList = operateList.map(function (topItem) {
                var processedChildren = [];
                // 找到当前一级项对应的有效子path数组
                var validChildPaths = menuPathMap[topItem.path] || [];

                // 过滤子项：只保留path在有效数组中的子项
                if (validChildPaths.length > 0) {
                    processedChildren = topItem.children.filter(function (child) {
                        return validChildPaths.indexOf(child.path) !== -1;
                    });
                }

                // 复制一级项属性，替换子项为过滤后的结果
                return {
                    name: topItem.name,
                    path: topItem.path,
                    children: processedChildren
                };
            });
            console.log("luyou", processedList)
            return processedList;
        },
        seleClick(item) {
            if (Number(this.seleId) === Number(item.id)) return;
            this.seleId = item.id;
            this.seleIdFun();
        },

        seleIdFun() {
            switch (Number(this.seleId)) {
                case 1:
                    this.aside = this.operateList;
                    this.$router.push({ path: '/main/level1/dashboardcompre' });
                    break;
                case 2:
                    this.aside = this.channelList;
                    this.$router.push({ path: '/main/level1/channelcore' });
                    break;
                case 3:
                    this.aside = this.goodsList;
                    this.$router.push({ path: '/main/level1/costset' });
                    break;
                case 4:
                    this.aside = this.setList;
                    this.$router.push({ path: '/main/level1/plateorder' });
                    break;
                case 5:
                    this.aside = this.revenList;
                    this.$router.push({ path: '/main/level1/revenbook' });
                    break;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.cont {
    width: 100%;
    min-height: 100vh;
    background: #13243e;
    display: flex;
    flex-direction: row;
    justify-content: start;
}

.left_wrapper {
    width: 134px;
}

.left_bar_img {
    margin: 20px 0;
    width: 87px;
    height: 87px;
    cursor: pointer;
    border-radius: 87px;
}

.left_bar_list {
    .left_bar_item {
        width: 93px;
        height: 79px;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .left_bar_item_img {
            width: 35px;
            height: 35px;
        }

        .left_bar_item_tit {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #bec5cf;
        }

        &.isact {
            background: #0d1625;
            border-radius: 10px;

            .left_bar_item_tit {
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #fff;
            }
        }
    }
}

.left_bar {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}

.right_wrapper {
    width: 1786px;
    height: 100%;
    background: #f7f8fc;
    border-radius: 20px 0px 0px 20px;
    display: flex;
    flex-direction: row;
    justify-content: start;
}

.right_menu {
    width: 206px;
}

.right_cont {
    width: 1580px;
    height: 100%;
    background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/level1.vue